export const insightCSS = {
  headingLabel: {
    fontWeight: 400,
    fontSize: 'var(--font-size-18)',
    fontFamily: 'Inter',
    color: 'var(--color-text-heading)',
    lineHeight: '1'
  },
  header: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  heading: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left'
  },
  subHeading: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-16)',
    color: 'var(--color-primary)'
  },
  titleLabel: {
    fontFamily: 'RalewayMedium',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineGeight: '16px',
    color: 'var(--color-primary)'
  },
  insightText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-16)',
    color: 'var(--color-text-grey-purple)'
  },
  insightLink: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-16)',
    textDecoration: 'underline',
    color: 'var(--color-primary)',
    marginTop: '5px',
    cursor: 'pointer'
  },
  insightRow: {
    background: 'var(--color-bg-page)',
    borderRadius: '4px',
    padding: '10px',
    height: '52px'
  },
  rowText: {
    color: 'var(--color-black)',
    textTransform: 'capitalize',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    overflow: 'hidden',
    maxWidth: '400px',
    textOverflow: 'ellipsis',
    lineHeight: 'var(--line-height-16)'
  },
  recommendRowText: {
    color: 'var(--color-black)',
    textTransform: 'capitalize',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 'var(--line-height-16)',
    whiteSpace: 'nowrap'
  },
  gscText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-text-grey-purple)'
  },
  gscHeading: {
    fontStyle: 'normal',
    fontWeight: 100,
    fontSize: 'var(--font-size-18)',
    lineHeight: '27px',
    color: 'var(--color-text-heading)'
  },
  insightURL: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-16)',
    color: 'var(--color-primary)'
  },
  insightRelease: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-22)',
    color: 'var(--color-black)'
  },
  insightTableRow: {
    background: 'var(--color-bg-page)',
    borderRadius: '4px',
    padding: '10px'
  },
  aIKeywordText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 550,
    fontSize: '13px',
    color: 'var(--color-primary)',
    lineHeight: '1.5'
  },
  insightRowText: {
    fontFamily: 'Inter',
    background: 'var(--color-bg-page)',
    borderRadius: '4px',
    padding: '10px',
    height: '52px'
  },
  scannedPagesSiteTitle: {
    color: 'var(--color-primary)',
    fontWeight: 700
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    marginTop: '5px'
  }
};

export const newAddScanModalSxs = {
  infoBoxSx: {
    marginTop: '24px',
    mt: 2,
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    gap: '8px',
    borderRadius: '8px',
    opacity: '0px',
    border: '1px solid var(--color-secondary)',
    backgroundColor: 'var(--color-success-bg-ultra)'
  },
  stepperBoxSx: {
    marginTop: '-10px'
  },
  inputFieldBoxSx: {
    marginTop: '24px'
  },
  nextStepBtnSx: {
    marginTop: '0px',
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px'
  },
  labelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginBottom: '4px'
  },
  relatedKeywordTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)'
  },
  relatedKeywordSpanSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-strong)'
  },
  textFieldsBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    marginTop: '24px',
    alignItems: 'start'
  },
  subLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  runScanBoxSx: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    justifyContent: 'end',
    marginTop: '32px'
  },
  mainBox: {
    paddingBottom: '24px'
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  skipTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-mid)',
    cursor: 'pointer'
  },
  nextBtnBoxSx: {
    textAlign: 'end'
  },
  countryTextFieldBoxSx: {
    width: '100%'
  },
  arrowIconSx: {
    marginLeft: '-8px'
  },
  infoBoxTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(31, 37, 42, 1)'
  },
  titleText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  closeIconSx: {
    height: '26px',
    width: '26px',
    color: 'var(--color-black)'
  },
  clickHereLink: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    textDecoration: 'underline',
    cursor: 'pointer'
  }
};
